<div class="header-container" nz-row nzJustify="space-between">

  <img src="../../../assets/icons/main-logo__black.svg"/>


  <nz-select [ngModel]="lang" (ngModelChange)="setLanguage($event)">
    <nz-option nzValue="ru" nzLabel="РУС "></nz-option>
    <nz-option nzValue="kz" nzLabel="QAZ "></nz-option>
    <nz-option nzValue="en" nzLabel="ENG "></nz-option>
  </nz-select>
</div>

